import { PageLoader } from '@forwardflow/ui/PageLoader'
import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

import { CampaignHome } from './components/CampaignHome'
import { CampaignList } from './components/CampaignList'
import { CampaignLeadSourceList } from './components/CampaignLeadSourceList'
import { ActivateCampaignPage } from './components/activate-campaign/ActivateCampaignPage'
import { PhoneNumberPage } from './components/phone-number/PhoneNumberPage'
import { SetAssistants } from './components/assistants/SetAssistants'
import { AgentAssignmentConfig } from './components/agent-assignment/AgentAssignmentConfig'
import { ConfigCampaignPage } from './components/activate-campaign/ConfigCampaignPage'

export const CampaignRoutes = () => {
   return (
      <Suspense fallback={<PageLoader />}>
         <Routes>
            <Route path="" element={<CampaignHome />}>
               <Route path="" element={<CampaignList />} />
               <Route path=":title" element={<CampaignLeadSourceList />} />
            </Route>
            <Route
               path=":title/activate"
               element={<ActivateCampaignPage />}
            />
            <Route path=":title" element={<ConfigCampaignPage />}>
               <Route path="phone-number" element={<PhoneNumberPage />} />
               <Route path="assistants" element={<SetAssistants />} />
               <Route
                  path="agent-assignment"
                  element={<AgentAssignmentConfig />}
               />
            </Route>
         </Routes>
      </Suspense>
   )
}
